module.exports = __webpack_public_path__ + "channels.png";